module.exports = __webpack_public_path__ + "assets/img/SG_cover.53167c93.jpg";